 function getDeviceTatio(document){
  return parseFloat(document.body.clientWidth/document.body.clientHeight)
}

export function RatioBetween(document){
    let ra = getDeviceTatio(document)
    return ra>19/10 && ra<195/100
  }
  